import { MetadataOptions } from "sap/ui/base/ManagedObject";
import { FilterBinding } from "../utils/BindingFilterUtil";
import ComboBoxBase from "sap/m/ComboBoxBase";

/**
 * This file implements options filtering based on user input when the total number of options is very large.
 *
 * Explanation:
 * UI5 has an issue where aggregation bindings are limited to 100 items. This is a problem for akamont,
 * because we can have thousands of partners, and ComboBox cannot display all options.
 * One solution is to increase the limit as stated here: https://community.sap.com/t5/technology-q-a/sap-m-combobox-only-shows-100-items/qaq-p/475696.
 * But that's not a good solution, because the browser lags when ComboBox has 3000+ options.
 * Instead, we apply filtering to the model every time user changes the input value.
 * Another issue is that ComboBox doesn't have a "live change" event, so we have to override the "oninput" function that typescript doesn't know about.
 */

export const ManyOptionsComboBoxMetadata: MetadataOptions = {
  properties: {
    // Binding path that the "text" property of Items is bound to, excluding the model name.
    // Required for item filtering based on user input.
    // E.g. if item's text is bound to "{options>name}", itemTextBindingPath should be "name".
    itemTextBindingPath: { type: "string" },
    // Same thing, but for additional text.
    itemAdditionalTextBindingPath: { type: "string" },
  },
};

export function ManyOptionsComboBoxUpdateItems(
  oComboBoxBase: ComboBoxBase,
  sReason: string
) {
  // this line is necessary to filter items if the "items" aggregation binding was updated after user input, e.g. on "selectionChange"
  if (sReason === "change") ManyOptionsComboBoxFilterOptions(oComboBoxBase);
}

export function ManyOptionsComboBoxFilterOptions(oComboBoxBase: ComboBoxBase) {
  FilterBinding(oComboBoxBase.getValue(), oComboBoxBase.getBinding("items"), [
    oComboBoxBase.getProperty("itemTextBindingPath"),
    oComboBoxBase.getProperty("itemAdditionalTextBindingPath"),
  ]);
}
